import { defineSlotRecipe } from '@chakra-ui/react';

export const menuSlotRecipe = defineSlotRecipe({
  className: 'chakra-menu',
  slots: [
    'trigger',
    'triggerButton',
    'content',
    'item',
    'itemText',
    'itemIndicator',
    'itemGroupLabel',
    'indicator',
    'itemCommand',
    'separator',
    'positioner',
  ],
  base: {
    trigger: {
      backgroundColor: 'neutral.800',
      color: 'white',
      border: '2px solid',
      borderColor: 'neutral.black',
      borderRadius: 0,
      height: '48px',
      width: '108px',
      cursor: 'pointer',
    },
    triggerButton: {
      backgroundColor: 'neutral.black',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      width: '44px',
      height: '44px',
      color: 'neutral.300',
      border: '2px solid',
      borderColor: 'neutral.800',
      cursor: 'pointer',
      _disabled: {
        color: 'neutral.700',
      },
      '&[data-active=true]': {
        backgroundColor: 'blue !important',
      },
      _groupHover: {
        backgroundColor: 'neutral.800',
        borderColor: 'skyBlue',
      },
      '&[data-disabled=true]': {
        backgroundColor: 'neutral.black !important',
      },
    },
    positioner: {
      borderRadius: 0,
    },
    content: {
      borderRadius: 0,
      backgroundColor: 'neutral.800',
      paddingX: '0 !important',
      paddingY: '0 !important',
      border: '2px solid',
      borderColor: 'neutral.black',
    },
    item: {
      borderRadius: 'none',
      backgroundColor: 'transparent',
      border: '2px solid',
      borderColor: 'neutral.800',
      cursor: 'pointer',
      color: 'neutral.white',
      _hover: {
        borderColor: 'skyBlue',
        backgroundColor: 'neutral.700',
        '&[data-selected="true"]': {
          backgroundColor: 'blue',
        },
      },
      '&[data-selected="true"]': {
        backgroundColor: 'blue',
        borderColor: 'blue',
      },
    },
  },
});
